import React from 'react'
import { Image, Menu } from 'semantic-ui-react'
import { logoBackground } from '../assets/logo';

const Navbar = ({handleItemClick}) => (
  <div className='Tile' styles={{
    position: 'fixed'
  }}>
  <Menu inverted secondary size='huge' stackable style={styles.root}>
    <Menu.Item>
      <Image src={logoBackground} size='mini'/>
    </Menu.Item>
    <Menu.Item header
      id='home'
      name='Ahanar Sajghar'
      style={{fontStyle: 'italic'}}
      onClick={handleItemClick}
    />
    <Menu.Menu position='right'>
      <Menu.Item
        id='product'
        name='Products'
        onClick={handleItemClick}
      />
      <Menu.Item
        id='video'
        name='Videos'
        onClick={handleItemClick}
      />
      <Menu.Item
        id='about'
        name='About'
        onClick={handleItemClick}
      />
      <Menu.Item
        id='contact'
        name='Contact'
        onClick={handleItemClick}
      />
    </Menu.Menu>
  </Menu>
  </div>
)

const styles = {
  root: {
    // backgroundColor: Theme.color.secondary,
    marginBottom: '-2px',
    paddingLeft: "4px",
    paddingRight: '4px',
  }
}

export {Navbar};